import { Languages } from "lucide-react";
import { Switch } from "./ui/switch";
import { detectLang } from "./ListingTranslate";

// "Also post in French/English" — the other language is picked from what the seller wrote.
export const BilingualToggle = ({ form, set, lang }) => {
  const fr = lang === "fr";
  const other = detectLang(`${form.title}\n${form.description}`) === "fr" ? "en" : "fr";
  const label = fr ? (other === "fr" ? "Publier aussi en français" : "Publier aussi en anglais") : (other === "fr" ? "Also post in French" : "Also post in English");
  const hint = fr
    ? "Nous traduisons automatiquement votre titre et votre description. Chaque visiteur voit l'annonce dans sa langue et peut revenir à l'original."
    : "We translate your title and description automatically. Each visitor sees the ad in their own language and can switch back to your original.";
  return (
    <label className="mt-4 flex items-start justify-between gap-4 rounded-xl border border-slate-200 bg-slate-50/60 px-4 py-3 cursor-pointer" data-testid="bilingual-toggle">
      <span>
        <span className="flex items-center gap-1.5 text-sm font-semibold text-[#12234A]"><Languages size={15} className="text-[#F5551E]" /> {label}</span>
        <span className="block text-xs text-slate-500 mt-0.5">{hint}</span>
      </span>
      <Switch checked={!!form.bilingual} onCheckedChange={(v) => set("bilingual", v)} data-testid="bilingual-switch" />
    </label>
  );
};
